<div class="app-confirm-delete opacity-hide" [class.opacity-show]="open" class="{{positionClass}} {{positionClassV}}">
    <div class="title">{{title}}</div>
    <p>{{descr}}</p>
    <div class="d-flex justify-content-between">
        <button class="button cancel" (click)="cancel.emit(true)">{{cancelButton}}</button>
        <button class="button confirm" (click)="confirm.emit(true)">{{confirmButton}}</button>
    </div>
</div>